import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createUser } from '../../../redux/user/user.actions';

import { ArrowBack } from '@material-ui/icons';
import { TextField, Select, MenuItem, Button, Grid, FormControl, InputLabel, Typography, IconButton } from '@mui/material';
import { ThemeContext } from '../../../components/ThemeContext/ThemeContext';
import CadastroDoRepresentante from '../../../components/CadastroDoRepresentante';
import MarcasQueAtende, { useMarcasDisponiveis } from '../../../components/MarcasQueAtende';
import { toast } from 'react-toastify';

const CreateOperatorPage = props => {
    const [serviceGroup, setServiceGroup] = useState(null);
    const [profile, setProfile] = useState(null);
    const [name, setName] = useState();
    const [password, setPassword] = useState();
    const [email, setEmail] = useState();
    const [hasError, setHasError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [serviceGroupError, setServiceGroupError] = useState(false);
    const [profileError, setProfileError] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState();
    // Cadastro do representante (itens 3 e 4). Um objeto só, e não cinco
    // estados soltos, porque é exatamente isso que o componente recebe e o
    // que o payload manda -- cinco `useState` aqui seriam cinco lugares de
    // onde esquecer um campo no `createUser`.
    // As marcas que o operador atende (Gisele, 19/10). Lista vazia e
    // "atende todas", que e o padrao certo para um cadastro novo.
    const [marcasQueAtende, setMarcasQueAtende] = useState([]);
    const marcasDisponiveis = useMarcasDisponiveis();
    const [representante, setRepresentante] = useState({
        representante_codigo: '',
        representante_company_id: null,
        responsavel_id: null,
        telefone: '',
    });
    const mudarRepresentante = (campo, valor) =>
        setRepresentante((atual) => ({ ...atual, [campo]: valor }));
    const { authError } = props;
    const { theme } = useContext(ThemeContext)

    useEffect(() => {
        let error;
        if (authError && authError.errorMessage) {
            error = JSON.parse(authError.errorMessage);
        } else {
            error = 'Sem Erro';
        }
        if (error.email) {
            switch (error.email[0]) {
                case 'The email has already been taken.':
                    setEmailError({ error: true, message: 'O email já está em uso' });
                    break;
                case "The email must be a valid email address.":
                    setEmailError({ error: true, message: 'O email deve ser um endereço de e-mail válido' });
                    break;
                default:
                    break;
            }
        }
        if (error.password) {
            switch (error.password[0]) {
                case 'The password must be at least 6 characters.':
                    setPasswordError({ error: true, message: 'A senha deve ter pelo menos 6 caracteres' });
                    break;
                default:
                    break;
            }
        } 
        if (error === 'Sem Erro') {
            setEmailError(false);
        }
        // A navegação em caso de sucesso é feita no handleCreateOperator,
        // após o await da criação concluir de fato.
        // eslint-disable-next-line
    }, [authError]);


    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const handleCreateOperator = async e => {
        e.preventDefault();

        const isServiceGroupValid = serviceGroup !== null;
        const isProfileValid = profile !== null;
        const isNameValid = name !== undefined && name.trim() !== '';
        const isPasswordValid = password !== undefined && password.trim() !== '';
        const isEmailValid = email !== undefined && email.trim() !== '' && validateEmail(email);
        const isConfirmPasswordValid = confirmPassword !== undefined && confirmPassword.trim() !== '' && confirmPassword === password;

        if (!isServiceGroupValid) setServiceGroupError(true);
        if (!isProfileValid) setProfileError(true);
        if (!isNameValid || !isPasswordValid || !isConfirmPasswordValid || !isEmailValid || !isServiceGroupValid || !isProfileValid) {
            setHasError(true);
            return;
        }

        try {
            await props.createUser({
                service_group_id: serviceGroup,
                name: name,
                password: password,
                profile_id: profile,
                email: email,
                status: 1,
                ...representante,
                whatsapp_number_ids: marcasQueAtende,
            });

            toast.success(`Operador criado com sucesso!`, {
                position: toast.POSITION.BOTTOM_CENTER,
                style: {
                    backgroundColor: theme.palette.background.toast,
                    color: theme.palette.success.contrastText,
                },
            });

            props.history.push('/operadores');
        } catch (error) {
            // O thunk já fez dispatch de setAuthError; o useEffect mapeia os
            // erros de e-mail/senha para os campos. Aqui só sinalizamos a falha
            // e permanecemos na tela para correção.
            setHasError(true);
            toast.error('Não foi possível criar o operador. Verifique os campos destacados.', {
                position: toast.POSITION.BOTTOM_CENTER,
                style: {
                    backgroundColor: theme.palette.background.toast,
                    color: theme.palette.error.contrastText,
                },
            });
        }
    };

    const handleGetBack = e => {
        e.preventDefault();
        props.history.push('operadores');
    };

    return (
        /* `xs` é prop de item; em container o MUI avisa. Os três primeiros
           valores do `sx` são o que o `xs={12}` gerava -- ver
           `src/avisosDoConsole.test.js`. */
        <Grid container sx={{ flexBasis: '100%', flexGrow: 0, maxWidth: '100%', height: '100%', backgroundColor: theme.palette.background.default }} alignItems={'flex-start'} justifyContent={'center'} spacing={0}>
            <Grid item xs={12} display="flex" justifyContent="flex-start" sx={{ padding: 2 }}>
                <IconButton onClick={handleGetBack} sx={{
                    "& .MuiSvgIcon-root": {
                        color: theme.palette.text.primary,
                    },
                }}>
                    <ArrowBack />
                </IconButton>
            </Grid>
            <Grid item xs={11} sx={{ height: '90vh' }}>
                <FormControl fullWidth margin="normal">
                    <TextField label="Nome" onChange={({ target }) => setName(target.value)}
                        required
                        variant='outlined'
                        error={hasError && !name}
                        helperText={!name && "O nome é obrigatório"}
                        inputProps={{ style: { color: theme.palette.text.secondary } }} />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <TextField
                        label="E-mail"
                        onChange={({ target }) => {
                            if (!validateEmail(target.value)) {
                                setEmailError({ error: true, message: 'O email deve ser um endereço de e-mail válido' });
                            } else {
                                setEmailError(false);
                            }
                            setEmail(target.value);
                        }}
                        required
                        type={'email'}
                        inputProps={{ style: { color: theme.palette.text.secondary } }}
                        variant='outlined'
                        error={emailError}
                        helperText={emailError && `${emailError ? emailError.message : 'O e-mail é obrigatório'}`}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                <TextField label="Senha" onChange={({ target }) => {
                        setPassword(target.value);
                        if (target.value === '' || target.value.length < 6) {
                            setPasswordError({ error: true, message: target.value === '' ? 'A senha é obrigatória' : 'A senha deve ter pelo menos 6 caracteres' });
                        } else {
                            setPasswordError({ error: false, message: '' });
                        }
                    }}
                        required
                        type={'password'} inputProps={{ style: { color: theme.palette.text.secondary } }}
                        variant='outlined'
                        error={passwordError.error}
                        helperText={passwordError.error ? passwordError.message : ''}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <TextField label="Confirmar Senha" onChange={({ target }) => setConfirmPassword(target.value)}
                        required
                        type={'password'} inputProps={{ style: { color: theme.palette.text.secondary } }}
                        variant='outlined'
                        error={hasError && (!confirmPassword || confirmPassword !== password)}
                        helperText={(hasError && !confirmPassword && "A confirmação da senha é obrigatória") || (hasError && confirmPassword !== password && "As senhas não coincidem")}
                    />
                </FormControl>

                <FormControl fullWidth margin="normal" error={serviceGroupError}>
                    <InputLabel>Grupo de Atendimento</InputLabel>
                    <Select
                        value={serviceGroup || ''}
                        onChange={({ target }) => {
                            setServiceGroup(target.value);
                            setServiceGroupError(false);
                        }}
                        label="Grupo de Atendimento"
                        variant='outlined'
                    >
                        {props.serviceGroups.map(group =>
                            <MenuItem value={group.id} defaultValue={1}>{group.description}</MenuItem>
                        )}
                    </Select>
                    {serviceGroupError && <Typography color="error">Este campo é obrigatório.</Typography>}
                </FormControl>

                <FormControl fullWidth margin="normal" error={profileError}>
                    <InputLabel>Perfil</InputLabel>
                    <Select
                        value={profile || ''}
                        onChange={({ target }) => {
                            setProfile(target.value);
                            setProfileError(false);
                        }}
                        label="Perfil"
                        variant='outlined'
                    >
                        {props.profiles.profiles.map(profile =>
                            <MenuItem value={profile.id} defaultValue={2}>{profile.name}</MenuItem>
                        )}
                    </Select>
                    {profileError && <Typography color="error">Este campo é obrigatório.</Typography>}
                </FormControl>

                <CadastroDoRepresentante
                    valores={representante}
                    aoMudar={mudarRepresentante}
                    operadores={props.users}
                />

                <MarcasQueAtende
                    marcas={marcasDisponiveis}
                    selecionadas={marcasQueAtende}
                    aoMudar={setMarcasQueAtende}
                />

                <Grid display="flex" justifyContent="center" marginTop={2}>
                    <Button variant="contained" sx={{ backgroundColor: theme.palette.button.secondary }} onClick={handleCreateOperator}>Criar Operador</Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

const mapStateToProps = state => {
    const { user, serviceGroups, profiles } = state;
    const { authError } = user;


    return {
        users: user.users,
        serviceGroups: serviceGroups.serviceGroups,
        profiles,
        authError
    };
};

const mapDispatchToProps = dispatch => ({
    createUser: data => dispatch(createUser(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateOperatorPage));